(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    window.onscroll = function() {
      var hideOnScroll = document.querySelectorAll('.hide-on-scroll');
      var showOnScroll = document.querySelectorAll('.show-on-scroll');
      var chatLiveLink = document.querySelector('.header__chat_live_link');
      var header = document.querySelector('header');
      var scrollDistance = window.scrollY;
  
      hideOnScroll.forEach(function(element) {
        if (scrollDistance > 0) {
          element.style.display = 'none';
        } else {
          element.style.display = 'block';
        }
      });  
      showOnScroll.forEach(function(element) {
        if (scrollDistance > 0) {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      });  
      if(scrollDistance > 0) {
        chatLiveLink.classList.add('chat_live_scroll')
        header.classList.add('header-scroll')
        document.body.classList.add('body-is-scrolling')
      } else {
        chatLiveLink.classList.remove('chat_live_scroll')
        header.classList.remove('header-scroll')
        document.body.classList.remove('body-is-scrolling')
      }
  };

  } catch(e) { console.error(e); }
})();
})();
